/*=========================================================================================
  File Name: moduleGroupMutations.js
  Description: Group Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_GROUP(state, group) {
		state.groups.unshift(group);
	},
	SET_ALARM(state, alarms) {
		state.alarms = alarms;
	},
	SET_BATTERY_ALARM(state, alarms) {
		state.batteryAlarms = alarms;
	},
	UPDATE_ALARM(state, alarm) {
		const alarmIndex = state.alarms.findIndex((p) => p.key === alarm.key);
		Object.assign(state.alarms[alarmIndex], alarm);
	},
	REMOVE_ALARM(state, alarmKey) {
		const alarmIndex = state.alarms.findIndex((alarm) => alarm.key === alarmKey);
		state.alarms.splice(alarmIndex, 1);
	},
	SET_GROUPS_ACTIVITY(state, groups) {
		state.groupsActivity = groups;
	},
	ADD_GROUP_ACTIVITY(state, groups) {
		let arrayNew = state.groupsActivity.concat(
			groups.filter((element) => state.groupsActivity.find((e) => e.id === element.id) === undefined)
		);
		state.groupsActivity = arrayNew;
	},
	REMOVE_GROUP_ACTIVITY(state, itemId) {
		const ItemIndex = state.groupsActivity.findIndex((p) => p.id === itemId);
		state.groupsActivity.splice(ItemIndex, 1);
	},
	CLEAN_GROUP_ACTIVITY(state) {
		state.groupsActivity = [];
	},
	REMOVE_ALARM_BY_ID(state, alarmId) {
		const alarmIndex = state.alarms.findIndex((alarm) => alarm.id === alarmId);
		state.alarms.splice(alarmIndex, 1);
	},
};
